export default __webpack_public_path__ + "static/media/N0164_SUNGLASSESxPM_REDM.076e955b.mp4";